import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { ExcelDragDropProps } from '../interfaces';
import styles from './ExcelDragDrop.module.css';
import {
  MINP_BSR_INVEN_CTGY,
  MINP_BSR_INVEN_ESD_AVG_SLS,
  MINP_BSR_INVEN_ESTMTD_DAY,
  MINP_BSR_INVEN_RSRV,
  MINP_BSR_INVEN_SEED_AGNG,
  MINP_BSR_INVEN_MTRL_PLNT_THRSHLD_QTY,
  MINP_BSR_MULTILVL_MAPPING,
  MINP_HFM_FXD_CRNCY_RT,
  MINP_HFM_FXD_CRNCY_RT_CSHFLW,
  MINP_BSR_ACCT_SUB_GR,
  MINP_BSR_DIM_CUSTOMER,
  MINP_BSR_DIM_VENDOR,
  MINP_BSR_EXCLUSON_ACCT,
  MINP_BSR_GCS_MAPPING,
  MINP_BSR_GCS_QTR_DATA,
  MINP_BSR_GCS_SUMMRY,
} from '../constants';
import * as XLSX from 'xlsx';
import {
  Insert_MINP_BSR_INVEN_CTGY,
  Insert_MINP_BSR_INVEN_ESD_AVG_SLS,
  Insert_MINP_BSR_INVEN_ESTMTD_DAY,
  Insert_MINP_BSR_INVEN_RSRV,
  Insert_MINP_BSR_INVEN_SEED_AGNG,
  Insert_MINP_BSR_INVEN_MTRL_PLNT_THRSHLD_QTY,
  Insert_MINP_BSR_MULTILVL_MAPPING,
  Insert_MINP_HFM_FXD_CRNCY_RT,
  Insert_MINP_HFM_FXD_CRNCY_RT_CSHFLW,
  Insert_MINP_BSR_ACCT_SUB_GR,
  Insert_MINP_BSR_DIM_CUSTOMER,
  Insert_MINP_BSR_DIM_VENDOR,
  Insert_MINP_BSR_EXCLUSON_ACCT,
  Insert_MINP_BSR_GCS_MAPPING,
  Insert_MINP_BSR_GCS_QTR_DATA,
  Insert_MINP_BSR_GCS_SUMMRY,
} from '../apiCalls';
import { Container, Spinner } from 'react-bootstrap';

// Central definition for filters (their expected headers, etc.)
const FILTER_DEFINITIONS = {
  [MINP_BSR_ACCT_SUB_GR.Name]: MINP_BSR_ACCT_SUB_GR,
  [MINP_BSR_INVEN_CTGY.Name]: MINP_BSR_INVEN_CTGY,
  [MINP_BSR_INVEN_ESD_AVG_SLS.Name]: MINP_BSR_INVEN_ESD_AVG_SLS,
  [MINP_BSR_INVEN_ESTMTD_DAY.Name]: MINP_BSR_INVEN_ESTMTD_DAY,
  [MINP_BSR_INVEN_RSRV.Name]: MINP_BSR_INVEN_RSRV,
  [MINP_BSR_INVEN_SEED_AGNG.Name]: MINP_BSR_INVEN_SEED_AGNG,
  [MINP_BSR_INVEN_MTRL_PLNT_THRSHLD_QTY.Name]: MINP_BSR_INVEN_MTRL_PLNT_THRSHLD_QTY,
  [MINP_BSR_MULTILVL_MAPPING.Name]: MINP_BSR_MULTILVL_MAPPING,
  [MINP_HFM_FXD_CRNCY_RT.Name]: MINP_HFM_FXD_CRNCY_RT,
  [MINP_HFM_FXD_CRNCY_RT_CSHFLW.Name]: MINP_HFM_FXD_CRNCY_RT_CSHFLW,
  [MINP_BSR_DIM_CUSTOMER.Name]: MINP_BSR_DIM_CUSTOMER,
  [MINP_BSR_DIM_VENDOR.Name]: MINP_BSR_DIM_VENDOR,
  [MINP_BSR_EXCLUSON_ACCT.Name]: MINP_BSR_EXCLUSON_ACCT,
  [MINP_BSR_GCS_MAPPING.Name]: MINP_BSR_GCS_MAPPING,
  [MINP_BSR_GCS_QTR_DATA.Name]: MINP_BSR_GCS_QTR_DATA,
  [MINP_BSR_GCS_SUMMRY.Name]: MINP_BSR_GCS_SUMMRY,
};

// Map each filter to its respective insert function
const INSERT_FUNCTION_MAP = {
  [MINP_BSR_INVEN_CTGY.Name]: Insert_MINP_BSR_INVEN_CTGY,
  [MINP_BSR_INVEN_ESD_AVG_SLS.Name]: Insert_MINP_BSR_INVEN_ESD_AVG_SLS,
  [MINP_BSR_INVEN_ESTMTD_DAY.Name]: Insert_MINP_BSR_INVEN_ESTMTD_DAY,
  [MINP_BSR_INVEN_RSRV.Name]: Insert_MINP_BSR_INVEN_RSRV,
  [MINP_BSR_INVEN_SEED_AGNG.Name]: Insert_MINP_BSR_INVEN_SEED_AGNG,
  [MINP_BSR_INVEN_MTRL_PLNT_THRSHLD_QTY.Name]: Insert_MINP_BSR_INVEN_MTRL_PLNT_THRSHLD_QTY,
  [MINP_BSR_MULTILVL_MAPPING.Name]: Insert_MINP_BSR_MULTILVL_MAPPING,
  [MINP_HFM_FXD_CRNCY_RT.Name]: Insert_MINP_HFM_FXD_CRNCY_RT,
  [MINP_HFM_FXD_CRNCY_RT_CSHFLW.Name]: Insert_MINP_HFM_FXD_CRNCY_RT_CSHFLW,
  [MINP_BSR_ACCT_SUB_GR.Name]: Insert_MINP_BSR_ACCT_SUB_GR,
  [MINP_BSR_DIM_CUSTOMER.Name]: Insert_MINP_BSR_DIM_CUSTOMER,
  [MINP_BSR_DIM_VENDOR.Name]: Insert_MINP_BSR_DIM_VENDOR,
  [MINP_BSR_EXCLUSON_ACCT.Name]: Insert_MINP_BSR_EXCLUSON_ACCT,
  [MINP_BSR_GCS_MAPPING.Name]: Insert_MINP_BSR_GCS_MAPPING,
  [MINP_BSR_GCS_QTR_DATA.Name]: Insert_MINP_BSR_GCS_QTR_DATA,
  [MINP_BSR_GCS_SUMMRY.Name]: Insert_MINP_BSR_GCS_SUMMRY,
};

// Duplicate-checking utility functions
const hasInventoryCategoryDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.MTRL_ID}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasInventoryEstimatedAverageSalesDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.MTRL_TYP}-${item.MTRL_ID}-${item.YR_MONTH_ID}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasInventoryEstimatedDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.MTRL_CTGY}-${item.YR_MONTH_ID}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasInventoryReservesDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.MATERIAL_ID}-${item.YR_MONTH_ID}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasInventorySeedAgingDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.MTRL_ID}-${item.YR_MONTH_ID}-${item.BUCKET}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasInventoryMaterialPlantThresholdDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.YR_MONTH_ID}-${item.PLANT}-${item.MTRL_ID}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasSapHfmMappingDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.ECC_GL_ACCOUNT}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasHfmFixedCurrencyDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.YR_ID}-${item.PRD_VAL}-${item.ENTTY_LBL_NM}-${item.ACCT_LBL_NM}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasSapGLSubgroupsDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.ECC_GL_ACCOUNT}-${item.COMP_CD}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasCustomerDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.SAP_AC}-${item.CUST_NO}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasVendorDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.SAP_AC}-${item.VENDOR_ID}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasExclusionAccountDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.ECC_GL_ACCOUNT}-${item.COMP_CD}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasGCSKeyControlDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.ACCOUNT_NO}-${item.KC}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasGCSFailedKeyControlDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.COMP_CD}-${item.QTR}-${item.YR_NM}-${item.KC}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

const hasGCSSummaryDuplicate = (data: any[]) => {
  const map: { [key: string]: number } = {};
  for (const item of data) {
    const key = `${item.KEY_PASS}-${item.YR_QTR}-${item.COMP_CODE}-${item.KEY_TYP}`;
    if (map[key]) return true;
    map[key] = 1;
  }
  return false;
};

// Map each filter to its respective duplicate-checking function
const DUP_CHECK_FUNCTION_MAP = {
  [MINP_BSR_INVEN_CTGY.Name]: hasInventoryCategoryDuplicate,
  [MINP_BSR_INVEN_ESD_AVG_SLS.Name]: hasInventoryEstimatedAverageSalesDuplicate,
  [MINP_BSR_INVEN_ESTMTD_DAY.Name]: hasInventoryEstimatedDuplicate,
  [MINP_BSR_INVEN_RSRV.Name]: hasInventoryReservesDuplicate,
  [MINP_BSR_INVEN_SEED_AGNG.Name]: hasInventorySeedAgingDuplicate,
  [MINP_BSR_INVEN_MTRL_PLNT_THRSHLD_QTY.Name]: hasInventoryMaterialPlantThresholdDuplicate,
  [MINP_BSR_MULTILVL_MAPPING.Name]: hasSapHfmMappingDuplicate,
  [MINP_HFM_FXD_CRNCY_RT.Name]: hasHfmFixedCurrencyDuplicate,
  [MINP_HFM_FXD_CRNCY_RT_CSHFLW.Name]: hasHfmFixedCurrencyDuplicate,
  [MINP_BSR_ACCT_SUB_GR.Name]: hasSapGLSubgroupsDuplicate,
  [MINP_BSR_DIM_CUSTOMER.Name]: hasCustomerDuplicate,
  [MINP_BSR_DIM_VENDOR.Name]: hasVendorDuplicate,
  [MINP_BSR_EXCLUSON_ACCT.Name]: hasExclusionAccountDuplicate,
  [MINP_BSR_GCS_MAPPING.Name]: hasGCSKeyControlDuplicate,
  [MINP_BSR_GCS_QTR_DATA.Name]: hasGCSFailedKeyControlDuplicate,
  [MINP_BSR_GCS_SUMMRY.Name]: hasGCSSummaryDuplicate,
};

// A helper function for all insert calls
async function handleInsert(
  insertFn: (data: any[], user: number) => Promise<any>,
  jsonData: any[],
  userGPID: number,
  onSuccess: (res: any) => void,
  onError: (msg: string) => void
) {
  try {
    const response = await insertFn(jsonData, userGPID);
    if (response) {
      onSuccess(response);
    } else {
      onError(
        'Failed to upload data to the server. Please verify the data and upload the file again.'
      );
    }
  } catch (err) {
    onError(
      'Failed to upload data to the server. Please verify the data and upload the file again.'
    );
  }
}

const ExcelDragDrop: React.FC<ExcelDragDropProps> = (
  props: ExcelDragDropProps
) => {
  const [activityLogLoading, setActivityLogLoading] = useState(false);

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      const file = acceptedFiles[0];
      if (!file) return;

      setActivityLogLoading(true);
      try {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target?.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          const jsonDataHeaders = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });

          if (jsonData.length === 0) {
            props.onError('The Excel file does not contain any data.');
            setActivityLogLoading(false);
            return;
          }

          const headers = jsonDataHeaders[0] as string[];
          const headersSize = headers.length;
          const filterDef = FILTER_DEFINITIONS[props.selectedFilter];

          const allHeadersValid = filterDef.Headers.every((header: string) =>
            headers.includes(header)
          );
          const headerSizeValid = filterDef.Headers_Size === headersSize;

          if (allHeadersValid && headerSizeValid) {
            const dupCheckFn = DUP_CHECK_FUNCTION_MAP[props.selectedFilter];
            const hasDuplicates = dupCheckFn ? dupCheckFn(jsonData) : false;

            if (hasDuplicates) {
              props.onError(
                'Duplicate records found. Please fix them and upload the file again.'
              );
              setActivityLogLoading(false);
            } else {
              const insertFn = INSERT_FUNCTION_MAP[props.selectedFilter];
              handleInsert(
                insertFn,
                jsonData,
                props.userGPID,
                (response) => {
                  props.onSuccess(response);
                  setActivityLogLoading(false);
                },
                (error) => {
                  props.onError(error);
                  setActivityLogLoading(false);
                }
              );
            }
          } else {
            props.onError('Expected columns are missing');
            setActivityLogLoading(false); // Hide spinner
          }
        };

        reader.onerror = function () {
          props.onError('Failed to read the Excel file. Please try again.');
          setActivityLogLoading(false); // Hide spinner
        };

        reader.readAsBinaryString(file);
      } catch (error) {
        props.onError('Failed to process the Excel file. Please try again.');
        setActivityLogLoading(false); // Hide spinner
      }
    },
    [props]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        '.xlsx',
      ],
    },
    multiple: false,
    // Setting these to undefined is optional if you don't need them:
    onDragEnter: undefined,
    onDragOver: undefined,
    onDragLeave: undefined,
  });

  // Destructure refKey and rename the rest of the props
  const { refKey, ...inputProps } = getInputProps();

  return (
    <div
      {...getRootProps({
        disabled: activityLogLoading,
      })}
      style={{
        border: '2px dashed #cccccc',
        borderRadius: '5px',
        textAlign: 'center',
        cursor: activityLogLoading ? 'not-allowed' : 'pointer',
        height: 'calc(80vh - 160px - 4rem)',
        alignContent: 'center',
        opacity: activityLogLoading ? 0.6 : 1,
      }}
    >
      <input {...inputProps} disabled={activityLogLoading} />
      {isDragActive && !activityLogLoading ? (
        <p>Drop the Excel file here...</p>
      ) : !activityLogLoading ? (
        <p>Drag & drop an Excel file here, or click to select one</p>
      ) : null}
      {activityLogLoading && (
        <Container className={styles.loadingScreen}>
          <Spinner animation='grow' />
          <p>Uploading Data</p>
        </Container>
      )}
    </div>
  );
};

export default ExcelDragDrop;
